import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

export default function ChartColumn({ data, keyProp }) {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (data && data[0]) {
      const b = data[0].map((item) => item.sum_all_payment);
      const dateTime = data[0].map((item) => item.date);
      const seriesData = [
        {
          name: 'จำนวนบิลทั้งหมด',
          data: b,
        },
      ];

      const newChartData = {
        series: seriesData,
        options: {
          chart: {
            type: 'bar',
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
          },
          xaxis: {
            categories: dateTime,
            // type: 'datetime',
            title: {
              text: 'วันที่',
            }, 
          },
          yaxis: {
            title: {
              text: 'จำนวนบิลทั้งหมด',
            },
          },
          fill: {
            // type: "gradient",
            // gradient: {
            //   shade: "light",
            //   type: "vertical",
            //   shadeIntensity: 0.5,
            //   inverseColors: false,
            //   opacityFrom: 1,
            //   opacityTo: 0.8,
            //   stops: [0, 100]
            // }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },

        },
      };

      setChartData(newChartData);
    }
  }, [data, keyProp]);

  if (!chartData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div id="chart" style={{ backgroundColor: '#F5F6FA' }}>
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={200}
          key={keyProp}
        />
      </div>
    </div>
  );
}
